import { render, staticRenderFns } from "./ResultCard.vue?vue&type=template&id=31128f60"
import script from "./ResultCard.vue?vue&type=script&lang=js"
export * from "./ResultCard.vue?vue&type=script&lang=js"
import style0 from "./ResultCard.vue?vue&type=style&index=0&id=31128f60&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31128f60')) {
      api.createRecord('31128f60', component.options)
    } else {
      api.reload('31128f60', component.options)
    }
    module.hot.accept("./ResultCard.vue?vue&type=template&id=31128f60", function () {
      api.rerender('31128f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/pricing/components/ResultCard.vue"
export default component.exports